import(/* webpackMode: "eager" */ "/home/app/tutorapp-alt/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/app/tutorapp-alt/node_modules/next/font/google/target.css?{\"path\":\"src/app/(public)/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"variable\":\"--font-theme-sans\",\"subsets\":[\"latin\"]}],\"variableName\":\"sansFont\"}");
;
import(/* webpackMode: "eager" */ "/home/app/tutorapp-alt/node_modules/next/font/google/target.css?{\"path\":\"src/app/(public)/layout.tsx\",\"import\":\"Roboto_Mono\",\"arguments\":[{\"variable\":\"--font-theme-mono\",\"subsets\":[\"latin\"]}],\"variableName\":\"monoFont\"}");
;
import(/* webpackMode: "eager" */ "/home/app/tutorapp-alt/node_modules/next/font/google/target.css?{\"path\":\"src/app/(public)/layout.tsx\",\"import\":\"Poppins\",\"arguments\":[{\"variable\":\"--font-theme-logo\",\"weight\":\"700\",\"subsets\":[\"latin\"]}],\"variableName\":\"poppinsFont\"}");
;
import(/* webpackMode: "eager" */ "/home/app/tutorapp-alt/src/app/(public)/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/home/app/tutorapp-alt/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/app/tutorapp-alt/src/components/BottomNavBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/app/tutorapp-alt/src/components/DecorativeDots.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/app/tutorapp-alt/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/app/tutorapp-alt/src/components/header/HeaderWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/app/tutorapp-alt/src/components/MobileScreenDetector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/app/tutorapp-alt/src/components/ReduxSync.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/app/tutorapp-alt/src/components/SharedRecorderInitializer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/app/tutorapp-alt/src/providers/ClientUserProvider.tsx");
